import {
  OrbitControls,
  PerspectiveCamera
} from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { forwardRef, memo, useEffect, useMemo, useRef } from "react";
import { Color, SRGBColorSpace, Vector3 } from "three";
import AxesHelper from "./helper/AxesHelper.jsx";
import LightElements from "./helper/LightElements.jsx";

const ManualModelPreview = forwardRef(({ model, scale, zoomValue }, ref) => {

  const cameraRef = useRef();

  useEffect(() => {
    if (cameraRef.current) {
      cameraRef.current.position.set(...zoom(zoomValue, new Vector3(1.0, 1.5, 3.0)));
    }
  }, []);

  useEffect(() => {
    if (cameraRef.current) {
      cameraRef.current.position.set(...zoom(zoomValue, cameraRef.current.position));
    }
  }, [zoomValue]);

  const zoom = (value, pos) => {
    pos = pos.normalize();
    return [pos.x * value, pos.y * value, pos.z * value]
  };

  return (
    <Canvas
      color={0xffffff}
      linear
      gl={{ preserveDrawingBuffer: true, outputColorSpace: SRGBColorSpace }}
      onCreated={({ gl }) => {
        gl.shadowMap.enabled = true;
      }}
    >
      <LightElements />
      <Box scale={scale} model={model} ref={ref} />
      <PerspectiveCamera makeDefault ref={cameraRef} onUpdate={(self) => self.position.set(...zoom(zoomValue, new Vector3(1.0, 1.5, 3.0)))} />
      <OrbitControls makeDefault enablePan={false} />
      <gridHelper args={[50, 50]} />
      <AxesHelper axisThickness={0.02} />
    </Canvas>
  );
});

const Box = memo(forwardRef(({ scale, model }, ref) => {
  const geometry = useMemo(() => {
    // either use a box or a cylinder
    if (model.type === "cube") {
      return <boxGeometry args={[model.length, model.height, model.depth]} />;
    } else {
      return <cylinderGeometry args={[model.radius, model.radius, model.height]} />
    }
  }, [model]);

  return (
    <mesh ref={ref} scale={[scale, scale, scale]} position={[0, model.height / 2, 0]}>
      {geometry}
      <meshPhysicalMaterial
        opacity={model.opacity}
        transparent={true}
        color={new Color(model.color)}
      />
    </mesh>
  );
}));

export default ManualModelPreview;
